import { usePath } from '../config/VideoAppContext';
export const usePathByMediaType = media => {
  const {
    videoDetailPath,
    livePath
  } = usePath();
  if (!media) return '';
  return media.type === 'LIVESTREAM' ? livePath(media) : videoDetailPath(media);
};